import React from 'react';
/* --- import Components ----*/
import { Section } from '../Section';
import { SectionTitle } from '../Typography/index';
import { TwoColumns } from '../Section/index';
import { AnchorButton } from '../Button';
import { SessionItem } from './index';
/* --- import Utils ----*/
import { SessionDateDisplay, handlePriceFormat } from '../../utils/helpers';
/* --- import Styles and Images ----*/
import sizes from 'src/style/sizes';
import colors from 'src/style/colors';
import { useMediaQueries } from '../../utils/MediaQueries';

const Apply = React.memo(({ nextSessions, fromFormationsPageType, id }) => {
  const mqs = useMediaQueries();
  let pricesFormatted;

  return (
    <Section theme="primary" id={id}>
      <TwoColumns
        tabletRow
        center
        withoutSpace
        sizeLeft={sizes.columnWidth.small}
        left={
          <div>
            {mqs.desktopUp ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <SectionTitle>
                  Prochaines <br /> sessions <br />
                  <span css={{ color: colors.yellow, textAlign: 'center' }}>
                    {fromFormationsPageType === 'E-Learning' ? (
                      <>
                        E-learning <br></br>+ mentoring
                      </>
                    ) : (
                      fromFormationsPageType
                    )}
                  </span>
                </SectionTitle>
                <AnchorButton
                  className="apply-btn"
                  to="/financements/"
                  state={{ fromFormationsPage: fromFormationsPageType }}
                  css={{ width: 275, marginTop: 55 }}
                >
                  Voir les financements
                </AnchorButton>
              </div>
            ) : (
              <div css={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <SectionTitle isCenter>
                  Prochaines sessions <br />
                  <span css={{ color: colors.yellow, textAlign: 'center' }}>
                    {fromFormationsPageType}
                  </span>
                </SectionTitle>
                <AnchorButton
                  className="apply-btn"
                  to="/financements/"
                  state={{ fromFormationsPage: fromFormationsPageType }}
                  css={{ width: 275, margin: '43px auto 20px' }}
                >
                  Voir les financements
                </AnchorButton>
              </div>
            )}
          </div>
        }
        sizeRight={sizes.columnWidth.large}
        right={
          <div>
            {nextSessions.map((session, index) => {
              pricesFormatted = handlePriceFormat(session);
              let date = SessionDateDisplay(nextSessions[index], fromFormationsPageType);
              date +=
                fromFormationsPageType === 'Alternance'
                  ? ', pour 15 à 17 mois'
                  : fromFormationsPageType === 'E-Learning'
                  ? ', pour 3 à 6 mois'
                  : ``;
              const withFormat =
                session.prices.some((p) => p.name === 'telepresentiel') ||
                fromFormationsPageType === 'E-Learning';
              return (
                <SessionItem
                  key={session.id}
                  date={date}
                  withFormat={withFormat}
                  priceIndividuals={pricesFormatted.priceIndividualsRightFormat}
                  priceCorporate={pricesFormatted.priceCorporateRightFormat}
                  priceRemote={
                    pricesFormatted.priceRemoteRightFormat !== ''
                      ? pricesFormatted.priceRemoteRightFormat
                      : pricesFormatted.priceIndividualsRightFormat
                  }
                  sessionId={session.id}
                  fromFormationsPageType={fromFormationsPageType}
                  isFull={session.isFull}
                />
              );
            })}
          </div>
        }
      />
    </Section>
  );
});

export default Apply;
